const clockInData = {
  regionName: '所属大区',
  areaName: '区域',
  cityName: '城市',
  clockInDate: '打卡时间段',
  taskPkgTypeNo: '任务类型',
  storeName: '门店名称',
  clockInUserName: '打卡人',
  clockInLocation: '打卡地点',
  customerName: '经销商',
  taskPkgNo: '任务编码',
  taskPkgName: '任务名称',
  createTime: '创建时间',
  taskPkgTypeName: '任务类型',
  msg: {}
};
export default clockInData



// WEBPACK FOOTER //
// ./src/page/dataManagement/clockInData/lang/clockInData.zh.js